import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SelectionCriterionType } from "../../../autogen/bff-api";
import { SELECTION_CRITERION_TYPE_OPTIONS } from "../../../common/procurement/publicProcurementOptions";

// Shared badge for a qualification criterion's type, used by both the buyer bid-detail view and the
// supplier read-only bid page so the two stay visually in sync. Renders nothing for an unknown type.
export const CriterionTypeBadge = ({ type }: { type: SelectionCriterionType | null | undefined }) => {
  const { t } = useTranslation();
  const option = type ? SELECTION_CRITERION_TYPE_OPTIONS.find((o) => o.value === type) : undefined;
  if (!option) return null;
  return (
    <Badge
      bg={option.badgeBg}
      color={option.badgeColor}
      textTransform="uppercase"
      px="2"
      py="0.5"
      borderRadius="md"
      w="fit-content"
    >
      {t(option.value)}
    </Badge>
  );
};
